import { apiClient } from './api/apiClient';
import {
  Shift,
  CreateShiftRequest,
  UpdateShiftRequest,
  ShiftFilter,
  PagedResponse,
  ApiResponse,
} from '../types';

class ShiftService {
  /**
   * Ottieni lista turni con filtri
   */
  async getShifts(filter?: ShiftFilter): Promise<PagedResponse<Shift>> {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.siteId) params.append('siteId', filter.siteId.toString());
      if (filter.employeeId) params.append('employeeId', filter.employeeId.toString());
      if (filter.startDate) params.append('startDate', filter.startDate);
      if (filter.endDate) params.append('endDate', filter.endDate);
      if (filter.status !== undefined) params.append('status', filter.status.toString());
      if (filter.page) params.append('page', filter.page.toString());
      if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
    }

    return await apiClient.get<PagedResponse<Shift>>(
      `/shifts?${params.toString()}`
    );
  }

  /**
   * Ottieni dettagli turno per ID
   */
  async getShiftById(id: number): Promise<Shift> {
    const response = await apiClient.get<ApiResponse<Shift>>(`/shifts/${id}`);

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Turno non trovato');
  }

  /**
   * Crea nuovo turno
   */
  async createShift(data: CreateShiftRequest): Promise<Shift> {
    const response = await apiClient.post<ApiResponse<Shift>>('/shifts', data);

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nella creazione del turno');
  }

  /**
   * Aggiorna turno esistente
   */
  async updateShift(id: number, data: UpdateShiftRequest): Promise<Shift> {
    const response = await apiClient.put<ApiResponse<Shift>>(
      `/shifts/${id}`,
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nell\'aggiornamento del turno');
  }

  /**
   * Cancella turno
   */
  async deleteShift(id: number): Promise<void> {
    await apiClient.delete(`/shifts/${id}`);
  }

  /**
   * Clock in - Inizia turno
   */
  async clockIn(id: number): Promise<Shift> {
    const response = await apiClient.post<ApiResponse<Shift>>(
      `/shifts/${id}/clock-in`
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nel clock in');
  }

  /**
   * Clock out - Termina turno
   */
  async clockOut(id: number): Promise<Shift> {
    const response = await apiClient.post<ApiResponse<Shift>>(
      `/shifts/${id}/clock-out`
    );

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.message || 'Errore nel clock out');
  }
}

// Export singleton instance
export const shiftService = new ShiftService();
